module.exports = __webpack_public_path__ + "img/target_pl.6ad98ed4.svg";